import { PbaComparabilitySearch } from '../pba-comparability-search';

export class AssociateJurisdictionModalPayload {
  compSearch: PbaComparabilitySearch;
}
